module.exports = __webpack_public_path__ + "static/media/WPMTest.965cdd0d.jpg";